import QuickorderHead from "components/Quickorder/QuickorderHead"
import QuickorderRow from "components/Product/ProductTable"
import { Table } from "elemental-react16"
import PropTypes from "prop-types"
import React from "react"
import shop from "shop/shop"

export default function QuickorderTable( { products, handleRemoveProduct, onChange } ) {
  return (

    <div className="QuickorderTable" style={{ overflowX: "auto" }}>
      <Table>
        <ProductRowMapper products={products} handleRemove={handleRemoveProduct} onChange={onChange}/>
      </Table>
    </div>
  )
}

QuickorderTable.propTypes = {
  handleRemoveProduct: PropTypes.func.isRequired,
  products:            PropTypes.any,
}

const ProductRowMapper = ( { products, handleRemove, onChange } ) => {
  let output = []
  let productsForTable = []
  products.forEach( ( product ) => {
    productsForTable.push(product)
  } )
  console.log("productsForTable", productsForTable)

  return <QuickorderRow cart={shop.cart} readOnly={false} products={productsForTable} handleRemove={handleRemove} onChange={onChange}/>
}



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Quickorder/QuickorderTable.js